import { metricsTrack } from '../../../utilities/analytics/index.js';
import { doMockApiCall } from '../../../utilities/backend-helpers/index.js';
import '../../../atoms/buttons/enums.js';
import { getLang } from '../../../utilities/dom-helpers/index.js';
import { apiResponseStub } from '../data/api-response-stub.js';

/* eslint-disable no-param-reassign */
let isFormStarted = false;
const setScrollTop = (scroll) => {
    document.body.scrollTop = scroll;
    document.documentElement.scrollTop = scroll;
};
const adjustFocus = (ctx, isEditStep, isLastStep = false) => {
    if (isEditStep ? true : !ctx.isLastStep) {
        setTimeout(() => {
            var _a, _b, _c;
            const expandedItem = ctx.renderRoot.querySelector('ops-step[isexpanded]');
            (_b = (_a = expandedItem === null || expandedItem === void 0 ? void 0 : expandedItem.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('button')) === null || _b === void 0 ? void 0 : _b.scrollIntoView();
            (_c = expandedItem === null || expandedItem === void 0 ? void 0 : expandedItem.querySelector('input.option')) === null || _c === void 0 ? void 0 : _c.focus();
        }, 0);
    }
    if (isLastStep) {
        const getResultsBtn = ctx.shadowRoot.querySelector('generic-button');
        setTimeout(() => {
            getResultsBtn === null || getResultsBtn === void 0 ? void 0 : getResultsBtn.scrollIntoView({
                block: 'end',
                inline: 'nearest',
                behavior: 'smooth',
            });
        }, 0);
    }
};
const setActiveStep = (stepsArr, ctx, idx, e) => {
    const target = e.target;
    if (target.tagName === 'OPS-STEP') {
        if (idx > 0 && !stepsArr[idx - 1].answered)
            return;
        stepsArr.forEach((s, i) => {
            ctx.currentStep = idx;
            s.active = idx === i;
        });
        adjustFocus(ctx, true);
    }
};
const metricsEvents = (s, ctx, optionIndex, isUnchecked) => {
    if (!s.options[optionIndex].isMultipleChoice) {
        metricsTrack('cevt_form_step_interaction', {
            dlv_form_name: ctx.formName,
            dlv_form_id: ctx.formId,
            dlv_form_type: ctx.formName,
            dlv_step_number: ctx.currentStep + 1,
            dlv_step_name: s.type,
        });
    }
    if (!isUnchecked) {
        metricsTrack('cevt_form_select_interaction', {
            dlv_form_name: ctx.formName,
            dlv_form_id: ctx.formId,
            dlv_form_type: ctx.formName,
            dlv_form_question_name: s.question,
            dlv_form_selection_name: s.selectedOptions
                ? s.selectedOptions[s.selectedOptions.length - 1]
                : '',
        });
    }
};
const setSelectedOption = (stepsArr, ctx, optionIndex, e) => {
    e.stopPropagation();
    e.preventDefault(); // prevent <label> from natively toggling the associated <input> if the event reaches it
    // DOM checked state is synced by live() on the next render — no direct target manipulation needed.
    if (!isFormStarted) {
        metricsTrack('cevt_form_start', {
            dlv_event_action: 'start',
            dlv_event_category: 'form',
            dlv_form_type: ctx.formName,
            dlv_form_name: ctx.formName,
            dlv_form_id: ctx.formId,
        });
        isFormStarted = true;
    }
    let isCurrentStepMultipleChoice = false;
    stepsArr.forEach((s, i) => {
        var _a;
        if (s.active && i === ctx.currentStep) {
            isCurrentStepMultipleChoice = !!s.isMultipleChoice;
            (_a = s.selectedOptions) !== null && _a !== void 0 ? _a : (s.selectedOptions = []);
            if (!isCurrentStepMultipleChoice) {
                // Single-select: clear all, mark only the clicked option
                s.options.forEach(opt => {
                    opt.selected = false;
                });
                s.options[optionIndex].selected = true;
                s.selectedOptions = [s.options[optionIndex].shortName];
            }
            else {
                // Multiselect: toggle based on the data model, not the DOM property
                const newSelected = !s.options[optionIndex].selected;
                s.options[optionIndex].selected = newSelected;
                // Derive selectedOptions from actual opt.selected state so it never
                // gets out of sync with the visual selection (avoids push/splice bugs)
                s.selectedOptions = s.options
                    .filter(o => o.selected)
                    .map(o => o.shortName);
            }
            const isUnchecked = isCurrentStepMultipleChoice && !s.options[optionIndex].selected;
            // For multiselect: answered only when at least one option is selected
            s.answered = isCurrentStepMultipleChoice
                ? s.selectedOptions.length > 0
                : true;
            metricsEvents(s, ctx, optionIndex, isUnchecked);
            // Only deactivate the step on single-select (auto-advance)
            if (!isCurrentStepMultipleChoice) {
                s.active = false;
            }
        }
    });
    ctx.isLastStep = ctx.currentStep === stepsArr.length - 1;
    if (!isCurrentStepMultipleChoice) {
        // Single-select: auto-advance to the next step
        if (!ctx.isLastStep) {
            ctx.currentStep += 1;
        }
        if (ctx.isLastStep) {
            ctx.canGetResults = true;
        }
        stepsArr[ctx.currentStep].active = true;
        ctx.steps = [...stepsArr];
        if (!ctx.isLastStep) {
            adjustFocus(ctx);
            return;
        }
        adjustFocus(ctx, false, true);
    }
    else {
        // Multiselect: stay on the current step; update canGetResults when on last step
        if (ctx.isLastStep) {
            const currentStepData = stepsArr[ctx.currentStep];
            ctx.canGetResults = !!(currentStepData.selectedOptions && currentStepData.selectedOptions.length > 0);
        }
        ctx.steps = [...stepsArr];
    }
};
const getQuestionnaireResults = (ctx) => {
    const stepsResults = JSON.parse(JSON.stringify(ctx.steps.filter(s => s.answered)));
    const questionnaireResults = [];
    for (const stepsResult of stepsResults) {
        const questionnaireResult = {
            type: '',
            options: [],
            apiReadyName: '',
        };
        stepsResult.options = stepsResult.options.filter((o) => o.selected);
        questionnaireResult.type = stepsResult.type;
        questionnaireResult.options = stepsResult.options;
        stepsResult.options.forEach((o) => {
            questionnaireResult.apiReadyName = [
                ...questionnaireResult.apiReadyName,
                o.value,
            ];
        });
        questionnaireResults.push(questionnaireResult);
    }
    return questionnaireResults;
};
const getCategories = (questionnaireResults) => {
    const namesArr = [];
    for (const questionnaireResult of questionnaireResults) {
        namesArr.push(...questionnaireResult.apiReadyName);
    }
    return namesArr;
};
const setFormFields = (data) => {
    const productNames = data.products.map(p => p.title).join(',');
    const productIccCodes = data.products.map(p => p.iccCode).join(',');
    const updateProductDetailsEvent = new CustomEvent('update-product-details', {
        detail: {
            productNameList: productNames,
            productIccCodeList: productIccCodes,
        },
    });
    window.dispatchEvent(updateProductDetailsEvent);
};
const getOptionNames = (questionnaireResults) => {
    const namesArr = [];
    for (const questionnaireResult of questionnaireResults) {
        let name = [];
        for (const option of questionnaireResult.options) {
            name = [...name, option.shortName];
        }
        namesArr.push({
            type: questionnaireResult.type,
            optionName: name.toString().split(',').join(', '),
        });
    }
    return namesArr;
};
const formSubmit = (e, ctx, endpoint) => {
    var _a;
    e.preventDefault();
    const results = getQuestionnaireResults(ctx);
    const productCategories = getCategories(results);
    ctx.selectedOptions = getOptionNames(results);
    ctx.formData = {
        categories: productCategories,
        language: (_a = getLang()) !== null && _a !== void 0 ? _a : 'en-us',
    };
    if (ctx.devEnvironment) {
        doMockApiCall(apiResponseStub, false)
            .then(r => {
            ctx.hasResults = true;
            ctx.apiResponseData = r;
            setScrollTop(0);
        })
            .catch(err => console.warn(err));
    }
    else {
        fetch(endpoint, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(ctx.formData),
        })
            .then(res => res.json())
            .then(data => {
            var _a, _b, _c, _d;
            ctx.hasResults = true;
            ctx.apiResponseData = data;
            setFormFields(data);
            setScrollTop(0);
            metricsTrack('cevt_form_submit', {
                dlv_event_category: 'form',
                dlv_event_action: 'submit',
                dlv_form_name: ctx.formName,
                dlv_form_type: ctx.formName,
                dlv_form_id: ctx.formId,
                dlv_button_text: (_b = (_a = e.target.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.primary-button')) === null || _b === void 0 ? void 0 : _b.innerText,
            });
            if ((_c = ctx.steps.find(s => s.active)) === null || _c === void 0 ? void 0 : _c.isMultipleChoice) {
                metricsTrack('cevt_form_step_interaction', {
                    dlv_form_name: ctx.formName,
                    dlv_form_id: ctx.formId,
                    dlv_form_type: ctx.formName,
                    dlv_step_number: ctx.currentStep + 1,
                    dlv_step_name: (_d = ctx.steps.find(s => s.active)) === null || _d === void 0 ? void 0 : _d.type,
                });
            }
        })
            .catch(err => console.warn(err));
    }
};
const resetStepsData = (ctx) => {
    for (let i = 0; i < ctx.steps.length; i += 1) {
        ctx.steps[i].active = i === 0;
        ctx.steps[i].answered = false;
        ctx.steps[i].selectedOptions = null;
        for (const option of ctx.steps[i].options) {
            option.selected = false;
        }
    }
};
const handleQuestionnareReset = (ctx) => {
    resetStepsData(ctx);
    ctx.currentStep = 0;
    ctx.canGetResults = !ctx.canGetResults;
    ctx.hasResults = !ctx.hasResults;
    setScrollTop(0);
};

export { formSubmit, getQuestionnaireResults, handleQuestionnareReset, setActiveStep, setFormFields, setScrollTop, setSelectedOption };
